import React,{useState,useEffect} from 'react';
import { base } from '../../utils/api';
import Loading from '../../smallLoader/Loading';
import { readFromLocalStorage } from '../../utils/util';

const CompiledReportButton = () => {
    const [exporting,setExporting] = useState(false)
    const [message,setMessage] = useState(false)

    //const quater = readFromLocalStorage("quater")
    const quater = "2024Q2"

    const handleExport = () => {
        setExporting(true)
        if(!quater){
            setMessage("quater not found")
            setExporting(false)
            return
        }
        
        const url = `${base}/compiled-label-report/${quater}`;  // Adjust URL if needed
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/xlsx',
            },
        })
        .then(response => {
            if (response.ok) {
                return response.blob();
            }else{
                setExporting(false)
                setMessage("sorry something went wrong")
                throw new Error('Network response was not ok.')
            }
            
        })
        .then(blob => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${quater}_compiled_label_summary_report.xlsx`); // Specify the filename
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setExporting(false)
            setMessage("Report generated successfully")
        })
        .catch(error => console.error('Export failed:', error));
    };

    useEffect(() => {
        if (message) {
          
          const timer = setTimeout(() => {
            setMessage(null);
          }, 6000);
    
          return () => clearTimeout(timer);
        }
      }, [message]);

    return (
        <div className='flex flex-col'>
        <button className='flex text-white bg-blue-700 py-2 px-4 text-xs text-center rounded-sm' onClick={handleExport}>
           {exporting ? <><Loading color="white" size={18} /> Generating report...</> :"Compiled Label report"} 
        </button>
        {message && <p className={`${message==="Report generated successfully" ? "text-green-600" : "text-red-500"} text-[10px]`}>{message}</p>}
        </div>
    );
};

export default CompiledReportButton;
